import { render, staticRenderFns } from "./SenderHistoryDialog.vue?vue&type=template&id=d2ed2100&scoped=true"
import script from "./SenderHistoryDialog.vue?vue&type=script&lang=js"
export * from "./SenderHistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./SenderHistoryDialog.vue?vue&type=style&index=0&id=d2ed2100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ed2100",
  null
  
)

export default component.exports